import { render, staticRenderFns } from "./FamilyOrderReview.vue?vue&type=template&id=d9745036&scoped=true&"
import script from "./FamilyOrderReview.vue?vue&type=script&lang=js&"
export * from "./FamilyOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./FamilyOrderReview.vue?vue&type=style&index=0&id=d9745036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9745036",
  null
  
)

export default component.exports